(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel-controls"] && !Shopify.designMode) return;
  try {
    class ScrollCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.controls = this.querySelector('[data-carousel-controls]');
      if (!this.track || !this.controls) return;
      this.prev = this.controls.querySelector('[data-carousel-prev]');
      this.next = this.controls.querySelector('[data-carousel-next]');
      this.prev.addEventListener('click', () => this.step(-1));
      this.next.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    step(direction) {
      const item = this.track.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
      const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: distance * direction * rtl, behavior: reduce ? 'auto' : 'smooth' });
    }

    update = () => {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = max <= 2;
      const position = Math.abs(this.track.scrollLeft);
      this.prev.disabled = position <= 2;
      this.next.disabled = position >= max - 2;
      const bar = this.controls.querySelector('[data-carousel-progress]');
      if (bar && this.track.scrollWidth > 0) {
        const size = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
        bar.style.setProperty('--progress-size', size.toFixed(4));
        bar.style.setProperty('--progress', max > 0 ? (position / max).toFixed(4) : '0');
      }
    };
  }
  if (!customElements.get('scroll-carousel')) customElements.define('scroll-carousel', ScrollCarousel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["contact-bubble"] && !Shopify.designMode) return;
  try {
    class ContactBubble extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;
      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.details.open) {
          this.details.open = false;
          this.details.querySelector('summary').focus();
        }
      };
      this.onClick = (event) => {
        if (this.details.open && !this.contains(event.target)) this.details.open = false;
      };
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onClick);
    }
  }
  if (!customElements.get('contact-bubble')) customElements.define('contact-bubble', ContactBubble);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.debouncedApply = window.Veloura.debounce((form) => this.apply(this.paramsFrom(form)), 600);
      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onInput);
      this.addEventListener('submit', this.onSubmit);
      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
    }

    paramsFrom(form) {
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(form)) {
        if (value !== '') params.append(key, value);
      }
      return params.toString();
    }

    onChange = (event) => {
      const form = event.target.closest('[data-facets-form]');
      if (!form || event.target.matches('[data-price-input]')) return;
      this.apply(this.paramsFrom(form));
    };

    onInput = (event) => {
      if (!event.target.matches('[data-price-input]')) return;
      this.debouncedApply(event.target.closest('[data-facets-form]'));
    };

    onSubmit = (event) => {
      const form = event.target.closest('[data-facets-form]');
      if (!form) return;
      event.preventDefault();
      this.apply(this.paramsFrom(form));
    };

    onClick = (event) => {
      const link = event.target.closest('[data-facet-link]');
      if (!link) return;
      event.preventDefault();
      const url = new URL(link.href, window.location.origin);
      const fromPagination = Boolean(link.closest('.pagination'));
      this.apply(url.searchParams.toString()).then(() => {
        if (fromPagination) this.querySelector('[data-results]')?.scrollIntoView({ block: 'start' });
      });
    };

    onPopState = () => {
      this.apply(window.location.search.slice(1), false);
    };

    async apply(params, push = true) {
      const url = `${window.location.pathname}${params ? `?${params}` : ''}`;
      this.controller?.abort();
      this.controller = new AbortController();
      this.classList.add('is-loading');
      try {
        const doc = await window.Veloura.fetchSection(url, this.sectionId, this.controller.signal);
        window.Veloura.swapRegions(doc, this);
        if (push) window.history.pushState({ facets: true }, '', url);
        const summary = this.querySelector('[data-results-summary]');
        window.Veloura.announce(summary ? summary.textContent.trim() : window.Veloura.strings.resultsUpdated);
        window.Veloura.observeReveal?.(this);
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(url);
      } finally {
        this.classList.remove('is-loading');
      }
    }
  }
  if (!customElements.get('facet-filters')) customElements.define('facet-filters', FacetFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-recipient"] && !Shopify.designMode) return;
  try {
    class GiftCardRecipient extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-recipient-toggle]');
      this.fields = this.querySelector('[data-recipient-fields]');
      const offset = this.querySelector('[data-recipient-offset]');
      if (offset) offset.value = new Date().getTimezoneOffset().toString();
      this.toggle?.addEventListener('change', () => this.sync());
      this.sync();
    }

    sync() {
      const on = this.toggle.checked;
      this.fields.hidden = !on;
      this.fields.querySelectorAll('input, textarea').forEach((el) => (el.disabled = !on));
    }
  }
  if (!customElements.get('gift-card-recipient')) customElements.define('gift-card-recipient', GiftCardRecipient);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-localization-form]');
    if (form && event.target.matches('select')) form.submit();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["map-embed"] && !Shopify.designMode) return;
  try {
    class MapEmbed extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-map-load]')?.addEventListener('click', () => {
        const template = this.querySelector('template');
        if (!template) return;
        this.querySelector('[data-map-consent]')?.remove();
        this.appendChild(template.content.cloneNode(true));
        this.querySelector('iframe')?.focus();
      });
    }
  }
  if (!customElements.get('map-embed')) customElements.define('map-embed', MapEmbed);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    class NewsletterPopup extends HTMLElement {
    static storageKey = 'veloura:newsletter-popup';

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.dialog.addEventListener('close', () => this.remember(Number(this.dataset.frequency) || 30));

      const submitted = window.location.hash === '#NewsletterPopup';
      if (submitted && this.dialog.querySelector('[data-form-status]')) {
        if (this.dialog.querySelector('.form-message--success')) this.remember(365);
        this.open();
        return;
      }

      if (this.dataset.preview === 'true') {
        this.open();
        return;
      }

      if (this.recentlyDismissed()) return;
      if (this.dataset.showMobile !== 'true' && window.matchMedia('(max-width: 749px)').matches) return;

      const delay = Math.max(2, Number(this.dataset.delay) || 12) * 1000;
      this.timer = window.setTimeout(() => this.open(), delay);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
    }

    recentlyDismissed() {
      try {
        const until = Number(window.localStorage.getItem(NewsletterPopup.storageKey));
        return until && until > Date.now();
      } catch (error) {
        return false;
      }
    }

    remember(days) {
      if (this.dataset.preview === 'true') return;
      try {
        window.localStorage.setItem(NewsletterPopup.storageKey, String(Date.now() + days * 86400000));
      } catch (error) {
        /* Storage unavailable: popup may show again next visit. */
      }
    }

    open() {
      if (document.querySelector('dialog[open]')) {
        this.timer = window.setTimeout(() => this.open(), 8000);
        return;
      }
      window.Veloura.openDialog(this.dialog);
    }
  }
  if (!customElements.get('newsletter-popup')) customElements.define('newsletter-popup', NewsletterPopup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-gallery-list]');
      if (!this.list) return;
      this.items = () => [...this.list.querySelectorAll('[data-media-id]')];
      this.indexEl = this.querySelector('[data-gallery-index]');

      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.step(1));
      this.addEventListener('click', this.onClick);

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) this.setCurrent(entry.target.dataset.mediaId, false);
          });
        },
        { root: this.list, threshold: [0.6] }
      );
      this.items().forEach((item) => this.observer.observe(item));

      if (this.hasAttribute('data-has-models')) this.setupModels();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    isSlider() {
      return this.list.scrollWidth > this.list.clientWidth + 2;
    }

    onClick = (event) => {
      const thumb = event.target.closest('[data-thumb-for]');
      if (thumb) {
        this.select(thumb.dataset.thumbFor);
        return;
      }
      const deferred = event.target.closest('[data-deferred-media]');
      if (deferred) this.loadDeferred(deferred);
    };

    step(direction) {
      const items = this.items();
      const current = items.findIndex((item) => item.classList.contains('is-current'));
      const next = items[Math.min(items.length - 1, Math.max(0, current + direction))];
      if (next) this.select(next.dataset.mediaId);
    }

    select(mediaId) {
      const target = this.list.querySelector(`[data-media-id="${mediaId}"]`);
      if (!target) return;
      const smooth = window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'auto';
      if (this.isSlider()) {
        this.list.scrollTo({ left: target.offsetLeft - this.list.offsetLeft, behavior: smooth });
      } else if (target.getBoundingClientRect().top < 0 || target.getBoundingClientRect().top > window.innerHeight) {
        target.scrollIntoView({ behavior: smooth, block: 'start' });
      }
      this.setCurrent(mediaId, true);
    }

    setCurrent(mediaId, fromUser) {
      const items = this.items();
      items.forEach((item, index) => {
        const active = item.dataset.mediaId === String(mediaId);
        item.classList.toggle('is-current', active);
        if (active && this.indexEl) this.indexEl.textContent = index + 1;
      });
      this.querySelectorAll('[data-thumb-for]').forEach((thumb) => {
        const active = thumb.dataset.thumbFor === String(mediaId);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
          if (fromUser) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    loadDeferred(button) {
      const template = button.parentElement.querySelector('template');
      if (!template) return;
      const content = template.content.cloneNode(true);
      const isModel = button.dataset.deferredMedia === 'model';
      button.replaceWith(content);
      const container = this.list.querySelector(`[data-media-id="${button.dataset.deferredId}"]`);
      const player = container?.querySelector('video, iframe, model-viewer');
      if (isModel) {
        this.loadModelViewer(player);
      } else if (player && player.tagName === 'VIDEO') {
        player.play().catch(() => {});
      }
      player?.focus?.();
    }

    loadModelViewer(element) {
      if (!window.Shopify || !Shopify.loadFeatures || !element) return;
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: (errors) => {
            if (errors || !window.Shopify.ModelViewerUI) return;
            new Shopify.ModelViewerUI(element);
          },
        },
      ]);
    }

    setupModels() {
      const json = this.querySelector('[data-product-models]');
      if (!json || !window.Shopify || !Shopify.loadFeatures) return;
      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: (errors) => {
            if (errors || !window.ShopifyXR) return;
            window.ShopifyXR.addModels(JSON.parse(json.textContent));
            window.ShopifyXR.setupXRElements();
          },
        },
      ]);
    }
  }
  if (!customElements.get('media-gallery')) customElements.define('media-gallery', MediaGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    selectedValueIds() {
      const ids = [];
      this.querySelectorAll('fieldset, [data-option-select]').forEach((group) => {
        if (group.matches('select')) {
          ids.push(group.selectedOptions[0]?.dataset.optionValueId);
        } else {
          ids.push(group.querySelector('input:checked')?.dataset.optionValueId);
        }
      });
      return ids.filter(Boolean);
    }

    onChange = (event) => {
      const target = event.target.matches('select') ? event.target.selectedOptions[0] : event.target;
      const productUrl = target?.dataset.productUrl;
      const ids = this.selectedValueIds();
      const baseUrl = productUrl && productUrl !== this.dataset.productUrl ? productUrl : this.dataset.productUrl;

      if (baseUrl !== this.dataset.productUrl) {
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set('option_values', ids.join(','));
        window.location.assign(url.toString());
        return;
      }

      this.dispatchEvent(new CustomEvent('variant:change-start', { bubbles: true }));
      this.render(ids);
    };

    async render(ids) {
      const sectionId = this.dataset.sectionId;
      const section = document.getElementById(`shopify-section-${sectionId}`) || this.closest('.shopify-section');
      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('option_values', ids.join(','));

      this.controller?.abort();
      this.controller = new AbortController();
      section?.classList.add('is-updating');
      try {
        const doc = await window.Veloura.fetchSection(url.toString(), sectionId, this.controller.signal);
        if (!section) return;
        // Read the state before swapping: swapRegions moves this element out of `doc`
        // into the page, so querying `doc` afterwards finds nothing.
        const state = doc.querySelector('[data-variant-state]');
        const variantId = state?.dataset.variantId || '';
        window.Veloura.swapRegions(doc, section);

        if (variantId) {
          section.querySelectorAll(`[data-variant-input="${sectionId}"]`).forEach((input) => {
            input.value = variantId;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        const mediaId = state?.dataset.mediaId;
        if (mediaId) section.querySelector('media-gallery')?.select(mediaId);

        if (variantId && this.dataset.updateUrl === 'true') {
          const pageUrl = new URL(window.location.href);
          pageUrl.searchParams.set('variant', variantId);
          pageUrl.searchParams.delete('option_values');
          window.history.replaceState({}, '', pageUrl.toString());
        }

        const summary = state?.dataset.summary;
        if (summary) window.Veloura.announce(summary);
        document.dispatchEvent(new CustomEvent('variant:changed', { detail: { sectionId, variantId } }));
      } catch (error) {
        if (error.name !== 'AbortError') window.Veloura.announce(window.Veloura.strings.cartError);
      } finally {
        section?.classList.remove('is-updating');
      }
    }
  }
  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);
  } catch(e) { console.error(e); }
})();

})();
